import React, { Component } from "react"

import "./ClinicianBanner.css"

export default class ClinicianBannerComponent extends Component {
  render() {
    const { header, subHeader, extraClass } = this.props

    return (
      <div className={`unlogged-training-image ${extraClass}`}>
        <div className="unlogged-training-banner-header">
          <strong>{header}</strong>
        </div>
        <div className="unlogged-training-banner-subheader">{subHeader}</div>
      </div>
    )
  }
}
